module.exports = __webpack_public_path__ + "static/media/ios-logo.f4561398.svg";